import { render, staticRenderFns } from "./ClubCardGettingConfirmation.vue?vue&type=template&id=0add1171&"
import script from "./ClubCardGettingConfirmation.vue?vue&type=script&lang=js&"
export * from "./ClubCardGettingConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0add1171')) {
      api.createRecord('0add1171', component.options)
    } else {
      api.reload('0add1171', component.options)
    }
    module.hot.accept("./ClubCardGettingConfirmation.vue?vue&type=template&id=0add1171&", function () {
      api.rerender('0add1171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/core/ClubCardGetting/components/common/ClubCardGettingConfirmation.vue"
export default component.exports